import React from "react";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NumberFormatCustomFiveDigits } from "../components/NumberFormatCustom.js";
import { TextField, Checkbox, Slider, Divider } from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import "./iryubun.css";
import { changeHaiguusha, changeChild } from "../actions/actions.js";
import Tutrial from "../components/Tutrial";
import TutrialImage1 from "../asset/tutrial/iry/tutrial1.gif";
import TutrialImage2 from "../asset/tutrial/iry/tutrial2.jpg";
import TutrialImage3 from "../asset/tutrial/iry/tutrial3.gif";
import TutrialImage4 from "../asset/tutrial/iry/tutrial4.gif";
import firebase from "../firebase";
import DisabledFamily from "../components/DisabledFamily.js";

const numToAlpha = (num) => {
  if (num === 1) {
    return "A";
  } else if (num === 2) {
    return "B";
  } else if (num === 3) {
    return "C";
  } else if (num === 4) {
    return "D";
  } else if (num === 5) {
    return "E";
  }
};

const firstDecimalPlace = (value) => Math.round(value * 10) / 10;

//遺留分侵害があるかをチェックするカスタムフック
const useCheckResult = (iryuubun, assetSum) => {
  const [resultSuccess, changeResultSuccess] = useState(0);

  const checkResult = (iryuubun, assetSum) => {
    if (iryuubun <= assetSum && !(iryuubun === 0 && assetSum === 0)) {
      changeResultSuccess(1);
    } else if (iryuubun > assetSum) {
      changeResultSuccess(-1);
    } else if (iryuubun === 0 && assetSum === 0) {
      changeResultSuccess(0);
    }
  };

  useEffect(() => {
    checkResult(iryuubun, assetSum);
  });

  if (resultSuccess === 1) {
    return " result-success ";
  } else if (resultSuccess === -1) {
    return " result-warning ";
  } else if (resultSuccess === 0) {
    return "";
  }
};

const HaiguushaResult = (props) => {
  const assetSum = Number(props.assets[0][0]) + Number(props.assets[0][1]);
  const insSum = Number(props.assets[0][2]) + Number(props.assets[0][3]);
  const iryuubun = Math.round(props.sum / 4);

  const successClassName = useCheckResult(iryuubun, assetSum);

  let successInsClassName = "";
  if (insSum === 0) {
    successInsClassName = " result-nothing";
  }

  let husoku = 0;

  if (iryuubun - assetSum >= 0) {
    husoku = iryuubun - assetSum;
  } else {
    husoku = 0;
  }

  useEffect(() => {
    // console.log('change iryubun status from haiguusha result');
    props.changeStatus(0, husoku, insSum);
  }, [props.assets]);

  useEffect(() => {
    // console.log('props.allOk from haiguusha: ', props.allOk);
  }, [props.allOk]);

  return (
    <div className="result-table">
      <table>
        <caption className="table-caption">配偶者</caption>
        <tbody>
          <tr>
            <td>法定相続分</td>
            <td style={{ width: "60px" }} className="result-status">
              1 / 2
            </td>
            <td className="asset-mount">
              {" "}
              {Intl.NumberFormat().format(Math.round(props.sum / 2))} 万円
            </td>
          </tr>
          <tr className={successClassName + props.allOk}>
            <td>遺留分</td>
            <td className="result-status">1 / 4</td>
            <td className="asset-mount">
              {" "}
              {Intl.NumberFormat().format(iryuubun)} 万円
            </td>
          </tr>
          <tr>
            <td>金融資産</td>
            <td></td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(Number(props.assets[0][1]))} 万円
            </td>
          </tr>
          <tr>
            <td>自宅・事業用資産</td>
            <td></td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(Number(props.assets[0][0]))} 万円
            </td>
          </tr>
          <tr className={successClassName + props.allOk}>
            <td>相続予定財産</td>
            <td className="result-status">
              {props.sum !== 0
                ? Intl.NumberFormat().format(
                  firstDecimalPlace((assetSum / props.sum) * 100)
                )
                : 0}{" "}
              %
            </td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(assetSum)} 万円
            </td>
          </tr>
          <tr
            className={
              (husoku !== 0 && props.pattern) + successClassName + props.allOk
            }
          >
            <td>遺留分不足額</td>
            <td></td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(husoku)} 万円
            </td>
          </tr>
          <tr className="space"></tr>
          <tr
            className={
              (insSum !== 0 && props.pattern) +
              successClassName +
              props.allOk +
              successInsClassName
            }
          >
            <td>生命保険金</td>
            <td className="result-status">固有</td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(insSum)} 万円
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const ChildResult = (props) => {
  const assetSum =
    Number(props.assets[props.i][0]) + Number(props.assets[props.i][1]);
  const insSum =
    Number(props.assets[props.i][2]) + Number(props.assets[props.i][3]);
  const iryuubun =
    props.haiguusha === 1
      ? Math.round(props.sum / 2 / 2 / props.child)
      : Math.round(props.sum / props.child / 2);

  const successClassName = useCheckResult(iryuubun, assetSum);

  let successInsClassName = "";
  if (insSum === 0) {
    successInsClassName = " result-nothing";
  }

  let husoku = 0;
  if (iryuubun - assetSum >= 0) {
    husoku = iryuubun - assetSum;
  } else {
    husoku = 0;
  }

  useEffect(() => {
    props.changeStatus(props.i, husoku, insSum);
    // console.log('change iryubun status from child result');
  }, [props.assets]);

  return (
    <div className="result-table">
      <table>
        <caption className="table-caption">子供{numToAlpha(props.i)}</caption>
        <tbody>
          <tr>
            <td>法定相続分</td>
            <td className="result-status" style={{ width: "60px" }}>
              1 / {props.haiguusha === 1 ? props.child * 2 : props.child}
            </td>
            <td className="asset-mount">
              {" "}
              {props.haiguusha === 1
                ? Intl.NumberFormat().format(
                  Math.round(props.sum / 2 / props.child)
                )
                : Intl.NumberFormat().format(
                  Math.round(props.sum / props.child)
                )}{" "}
              万円
            </td>
          </tr>
          <tr className={successClassName + props.allOk}>
            <td>遺留分</td>
            <td className="result-status">
              1 / {props.haiguusha === 1 ? props.child * 4 : props.child * 2}
            </td>
            <td className="asset-mount">
              {" "}
              {Intl.NumberFormat().format(iryuubun)} 万円
            </td>
          </tr>
          <tr>
            <td>金融資産</td>
            <td></td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(Number(props.assets[props.i][1]))}{" "}
              万円
            </td>
          </tr>
          <tr>
            <td>自宅・事業用資産</td>
            <td></td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(Number(props.assets[props.i][0]))}{" "}
              万円
            </td>
          </tr>
          <tr className={successClassName + props.allOk}>
            <td>相続予定財産</td>
            <td className="result-status">
              {props.sum !== 0
                ? Intl.NumberFormat().format(
                  firstDecimalPlace((assetSum / props.sum) * 100)
                )
                : 0}{" "}
              %
            </td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(assetSum)} 万円
            </td>
          </tr>
          <tr
            className={
              (husoku !== 0 && props.pattern) + successClassName + props.allOk
            }
          >
            <td>遺留分不足額</td>
            <td></td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(husoku)} 万円
            </td>
          </tr>
          <tr className="space"></tr>
          <tr
            className={
              (insSum !== 0 && props.pattern) +
              successClassName +
              props.allOk +
              successInsClassName
            }
          >
            <td>生命保険金</td>
            <td className="result-status">固有</td>
            <td className="asset-mount">
              {Intl.NumberFormat().format(insSum)} 万円
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Result = (props) => {
  const [iryuubunStatus, changeIyuurbunStatus] = useState([
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
  ]);
  const [allOk, switchAllOk] = useState(null);
  const [pattern, changePattern] = useState("");
  const [calculationCount, changeCalculationCount] = useState(0);

  const changeStatus = (i, husoku, insSum) => {
    let newStatus = [...iryuubunStatus];
    newStatus[i][0] = husoku;
    newStatus[i][1] = insSum;
    changeIyuurbunStatus(newStatus);
  };

  //最終結果のパターン
  // 0: 遺留分不足なし
  // 1: 遺留分侵害があるが、生命保険金で支払い可能
  // 2: 1かつ、遺留分不足者が生命保険金を受け取っている
  // 3: 遺留分侵害があるが、生命保険金で支払い不可能
  // 4: 3かつ、遺留分不足者が生命保険金を受け取っている

  useEffect(() => {
    // console.log( 'iryuubunstatus',iryuubunStatus);
    //console.log("props:", props);
    const { home, finance, sum } = props;
    // console.log('home, finance :', home, finance);
    // console.log('home === 0 && alreadyIns === 0 && finance === 0 && newIns === 0', home === 0 && alreadyIns === 0 && finance === 0 && newIns === 0);
    // console.log('(iryuubunStatus[0][0] + iryuubunStatus[1][0] + iryuubunStatus[2][0] + iryuubunStatus[3][0] + iryuubunStatus[4][0] + iryuubunStatus[5][0]) === 0 :',(iryuubunStatus[0][0] + iryuubunStatus[1][0] + iryuubunStatus[2][0] + iryuubunStatus[3][0] + iryuubunStatus[4][0] + iryuubunStatus[5][0]) === 0)
    // console.log('(Number(home) + Number(finance)) === 0:', (Number(home) + Number(finance)) === 0);
    if (Number(home) + Number(finance) === 0) {
      //入力がない、もしくは0の場合
      switchAllOk(null);
      // console.log('allok1: ',allOk);
    } else if (
      iryuubunStatus[0][0] +
      iryuubunStatus[1][0] +
      iryuubunStatus[2][0] +
      iryuubunStatus[3][0] +
      iryuubunStatus[4][0] +
      iryuubunStatus[5][0] ===
      0
    ) {
      //遺留分不足がない場合
      switchAllOk(" all-ok ");
      // console.log('allok2:',allOk);
    } else {
      //遺留分不足がある場合
      switchAllOk(null);
    }

    let husokuSum = 0;
    let insSumHusoku = 0;
    let insSumNotHusoku = 0;
    let count = 0;
    let orangeAlertFlag = false;
    for (let i = 0; i <= 5; i++) {
      const husoku = iryuubunStatus[i][0];
      const ins = iryuubunStatus[i][1];
      // console.log('husoku,hoken:', husoku, ins)
      if (husoku !== 0 && ins === 0) {
        husokuSum += husoku;
        count++;
      }
      if (husoku === 0 && ins !== 0) {
        insSumNotHusoku += ins;
        count++;
      }
      if (husoku !== 0 && ins !== 0) {
        // console.log('不足者に保険');
        //遺留分不足かつ保険が割り当てられている相続人はカウントせず、オレンジのスタイルを適用するためのフラグをたてる
        husokuSum += husoku;
        insSumHusoku += ins;
        orangeAlertFlag = true;
      }
    }
    // console.log('orangeAlertFlag1', orangeAlertFlag)
    // console.log('count',count);
    // console.log('insSumHusoku', insSumHusoku);
    // console.log('insSumNotHusoku', insSumNotHusoku)

    if (count === Number(props.child) + 1) {
      orangeAlertFlag = false;
    }
    count = 0;

    // console.log('orangeAlertFlag2', orangeAlertFlag);

    const insSum = insSumHusoku + insSumNotHusoku;

    if (husokuSum === 0 && insSum === 0) {
      props.handleMessage("");
    } else if (
      iryuubunStatus[0][0] +
      iryuubunStatus[1][0] +
      iryuubunStatus[2][0] +
      iryuubunStatus[3][0] +
      iryuubunStatus[4][0] +
      iryuubunStatus[5][0] ===
      0
    ) {
      props.handleMessage(0);
    } else if (insSumNotHusoku >= husokuSum && !orangeAlertFlag) {
      props.handleMessage(1);
      changePattern(" blue-border ");
    } else if (insSumNotHusoku < husokuSum && !orangeAlertFlag) {
      props.handleMessage(2);
      changePattern(" red-border ");
    }
    if (insSumNotHusoku >= husokuSum && orangeAlertFlag) {
      props.handleMessage(3);
      changePattern(" orange-border ");
    } else if (insSumNotHusoku < husokuSum && orangeAlertFlag) {
      props.handleMessage(4);
      changePattern(" orange-border ");
    }

    let count2 = 0;
    for (let i = 0; i <= 5; i++) {
      //console.log("(sum * 0.3) < iryuubunStatus[i][1]:", (sum * 0.3) < iryuubunStatus[i][1]);
      if (sum * 0.3 < iryuubunStatus[i][1]) {
        count2 += 1;
      }
    }
    if (count2 >= 1) {
      props.handleMessage2(true);
    } else {
      props.handleMessage2(false);
    }

    const analytics = firebase.analytics();

    analytics.logEvent("calculation");
    changeCalculationCount(calculationCount + 1);
    //console.log(calculationCount);
    if (calculationCount % 10 === 0) {
      //console.log("calculate 10 times :", this.state.calculationCount);
      analytics.logEvent("calculate10times");
    }
  }, [iryuubunStatus]);

  const childResult = [];
  for (let i = 1; i <= props.child; i++) {
    childResult.push(
      <ChildResult
        haiguusha={props.haiguusha}
        child={props.child}
        assets={props.assets}
        sum={props.sum}
        changeStatus={changeStatus}
        allOk={allOk}
        pattern={pattern}
        i={i}
        key={i}
      />
    );
  }

  return props.error1 || props.error2 ? null : (
    <div className="result-box">
      {props.haiguusha === 1 && (
        <HaiguushaResult
          assets={props.assets}
          sum={props.sum}
          changeStatus={changeStatus}
          pattern={pattern}
          allOk={allOk}
        />
      )}
      {childResult}
    </div>
  );
};

const Iryubun = () => {
  const haiguusha = useSelector((state) => state.user.haiguusha);
  const child = useSelector((state) => state.user.child);
  const isPaid = useSelector((state) => state.user.isPaid);
  const needEmailVerify = useSelector((state) => state.user.needEmailVerify);
  const dispatch = useDispatch();

  const [home, changeHome] = useState("");
  const [finance, changeFinance] = useState("");
  const [alreadyIns, changeAlreadyIns] = useState("");
  const [newIns, changeNewIns] = useState("");

  const [assets, changeAssets] = useState([
    ["", "", "", ""],
    ["", "", "", ""],
    ["", "", "", ""],
    ["", "", "", ""],
    ["", "", "", ""],
    ["", "", "", ""],
  ]);

  const sum = Number(finance) + Number(home) - Number(newIns);

  const [error1, changeError1] = useState(null);
  const [error2, changeError2] = useState(null);

  const [message, changeMessage] = useState([["", ""], ""]);
  const [message2, changeMessage2] = useState(["", ""]);

  useEffect(() => {
    let newAssets = [...assets];
    let financeSum = 0;
    for (let i = 0; i <= 5; i++) {
      financeSum += Number(newAssets[i][1]);
    }
    if (financeSum > finance - newIns) {
      changeError1("合計が一致していません");
    } else if (financeSum < finance - newIns) {
      changeError1("合計が一致していません");
    } else if (financeSum === finance - newIns) {
      changeError1(null);
    }
    if (finance - newIns < 0) {
      changeError2("④が③を上回っています");
    } else if (finance - newIns >= 0) {
      changeError2(null);
    }
  });

  let errorClassName1 = "";
  if (error1) {
    errorClassName1 += "errorArea";
  }

  let errorClassName2 = "";
  if (error2) {
    errorClassName2 += "errorArea";
  }

  const handleMessage = (pattern) => {
    if (pattern === 0) {
      changeMessage([["", "遺留分侵害はありません"], " message "]);
    } else if (pattern === 1) {
      changeMessage([
        ["", "遺留分侵害がありますが、保険金で支払可能です"],
        " message1 ",
      ]);
    } else if (pattern === 2) {
      changeMessage([
        ["", "遺留分侵害があり、保険金での支払は不可能です"],
        " message2 ",
      ]);
    } else if (pattern === 3) {
      changeMessage([
        [
          "遺留分不足者が保険金受取人です",
          "遺留分侵害がありますが、保険金で支払可能です",
        ],
        " message3 ",
      ]);
    } else if (pattern === 4) {
      changeMessage([
        [
          "遺留分不足者が保険金受取人です\n",
          "遺留分侵害があり、保険金での支払は不可能です",
        ],
        " message3 ",
      ]);
    } else if (pattern === "") {
      changeMessage([["", ""], ""]);
    }
  };

  const handleMessage2 = (flag) => {
    if (flag) {
      changeMessage2([
        "[警告] 保険金の割合が高いのでご注意下さい",
        " message4 ",
      ]);
    } else {
      changeMessage2(["", " "]);
    }
  };

  const familyList = [];
  if (haiguusha === 1) {
    familyList.push(
      <option value={0} key={0}>
        配偶者
      </option>
    );
  }
  for (let i = 1; i <= child; i++) {
    familyList.push(
      <option value={i} key={i}>
        子{numToAlpha(i)}
      </option>
    );
  }

  const familyRow = [];
  if (haiguusha === 1) {
    familyRow.push(
      <tr key={0} className={errorClassName1 + " finance"}>
        <td></td>
        <td className="small-title">配偶者</td>
        <td className="asset-mount side-border">
          <TextField
            onChange={(event) => distributeFinance(event, 0)}
            value={assets[0][1]}
            InputProps={{
              inputComponent: NumberFormatCustomFiveDigits,
              type: "tel",
              style: { fontSize: 12 },
            }}
            fullWidth={true}
            color={"secondary"}
          />
        </td>
      </tr>
    );
  }
  for (let i = 1; i <= child; i++) {
    familyRow.push(
      <tr key={i} className={errorClassName1 + " finance"}>
        <td>&nbsp;</td>
        <td class="small-title">子{numToAlpha(i)}</td>
        <td className="asset-mount side-border">
          <TextField
            onChange={(event) => distributeFinance(event, i)}
            value={assets[i][1]}
            InputProps={{
              inputComponent: NumberFormatCustomFiveDigits,
              type: "tel",
              style: { fontSize: 12 },
            }}
            fullWidth={true}
            color={"secondary"}
          />
        </td>
      </tr>
    );
  }

  const homeRef = useRef(0);
  const alreadyInsRef = useRef(0);
  const newInsRef = useRef(0);

  const changeHomeAsset = (event) => {
    let value = Number(event.target.value);
    if (value === 0 || isNaN(value)) {
      console.log("value 0 or NaN:", value);
      value = "";
    }
    let newAssets = [...assets];
    // console.log('homeRef.current.value', homeRef.current.value);
    const who = Number(homeRef.current.value);
    newAssets[who][0] = value;
    changeAssets(newAssets);
    changeHome(value);
  };

  const changeFinanceAsset = (event) => {
    let value = Number(event.target.value);
    if (value === 0 || isNaN(value)) {
      //console.log("value 0 or NaN:", value);
      value = "";
    }
    if (value === 0 || isNaN(value)) {
      value = "";
    }
    changeFinance(value);
  };

  const distributeFinance = (event, who) => {
    let value = Number(event.target.value);
    if (value === 0 || isNaN(value)) {
      //console.log("value 0 or NaN:", value);
      value = "";
    }
    let newAssets = [...assets];
    newAssets[who][1] = value;
    changeAssets(newAssets);
  };

  const changeAlreadyInsAsset = (event) => {
    let value = Number(event.target.value);
    if (value === 0 || isNaN(value)) {
      //console.log("value 0 or NaN:", value);
      value = "";
    }
    let newAssets = [...assets];
    const who = Number(alreadyInsRef.current.value);
    newAssets[who][2] = value;
    changeAssets(newAssets);
    changeAlreadyIns(value);
  };

  const changeNewInsAsset = (event) => {
    let value = Number(event.target.value);
    if (value === 0 || isNaN(value)) {
      //console.log("value 0 or NaN:", value);
      value = "";
    }
    let newAssets = [...assets];
    const who = Number(newInsRef.current.value);
    newAssets[who][3] = value;
    changeAssets(newAssets);
    changeNewIns(value);
  };

  const assignAssets = (who, type) => {
    // console.log("who: ", who, "type: ", type);
    let newAssets = [...assets];
    for (let i = 0; i <= 5; i++) {
      newAssets[i][type] = "";
    }
    let newValue;
    if (type === 0) {
      newValue = home;
    } else if (type === 1) {
      newValue = finance;
    } else if (type === 2) {
      newValue = alreadyIns;
    } else if (type === 3) {
      newValue = newIns;
    }
    newAssets[who][type] = newValue;
    // console.log('homeRef.current.value assign', homeRef);
    changeAssets(newAssets);
    // console.log('asset', assets);
  };

  const reset = () => {
    let newAssets = [...assets];
    newAssets = [
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
    ];
    changeAssets(newAssets);
    changeHome("");
    changeFinance("");
    changeAlreadyIns("");
    changeNewIns("");
    changeMessage([["", ""], ""]);
  };

  const [tutrial, setTutrial] = useState(false);

  const closeTutrial = () => {
    localStorage.setItem("tutrial4", "ended");
    setTutrial(false)
  };
   
  useEffect(() => {
    const ended = localStorage.getItem("tutrial4");
    // console.log("ended: ", ended);
    if (ended) {
      setTutrial(false);
    } else {
      setTutrial(true);
    }
  }, [])


  return (
    <>
    {tutrial ? <Tutrial closeTutrial={closeTutrial} image1={TutrialImage1} image2={TutrialImage2} image3={TutrialImage3} image4={TutrialImage4} /> : (
      <section className="container">
      <div className="userArea">
        {(isPaid && !needEmailVerify) ? (
          <div className="family-table">
            <div className="haiguusha-box">
              <span className="family-title">配偶者</span>は{" "}
              {haiguusha === 1 ? "有り" : "無し"}
              <FormControlLabel
                control={<Checkbox
                  checked={haiguusha === 1}
                  onChange={() => {
                    dispatch(changeHaiguusha(haiguusha === 1 ? 0 : 1));
                    reset();
                  }}
                />}
                label="有無"
                labelPlacement="start"
              />

            </div>
            <div className="child-box">
              <div style={{ textAlign: "center", fontSize: "16px" }}>
                <span className="family-title">子供の数</span>: {child} 人
              </div>
              <Slider
                value={child}
                max={5}
                min={1}
                step={1}
                onChange={(event, newValue) => {
                  dispatch(changeChild(newValue));
                  reset();
                }}
                marks={true}
                color={"secondary"}
              />
            </div>
          </div>
        ) : (
          <DisabledFamily haiguusha={haiguusha} child={child} />
        )}

        <p className="errorArea">①～④の番号順に入力してください⇓</p>

        <table className="main-table">
          <tbody>
            <tr>
              <th className="asset-title small-title">所有資産</th>
              <th className="small-title">相続人/受取人</th>
              <th className="small-title" style={{ width: "100px" }}>
                金額(時価)
              </th>
            </tr>
            <tr className="home">
              <td className="asset-title">① 自宅・事業資産</td>
              <td>
                <select
                  ref={homeRef}
                  onChange={(event) => assignAssets(event.target.value, 0)}
                >
                  {familyList}
                </select>
              </td>
              <td className="asset-mount">
                {/* <input className="asset-mount" type="text" inputMode="numeric" maxLength="5" value={home} onChange={(event) => changeHomeAsset(event)} /> 万円 */}
                <TextField
                  onChange={(event) => changeHomeAsset(event)}
                  value={home}
                  InputProps={{
                    inputComponent: NumberFormatCustomFiveDigits,
                    type: "tel",
                  }}
                  fullWidth={true}
                  color={"secondary"}
                />
              </td>
            </tr>
            <tr className="alreadyIns">
              <td className="asset-title">② 生命保険金(既)</td>
              <td>
                <select
                  ref={alreadyInsRef}
                  onChange={(event) => assignAssets(event.target.value, 2)}
                >
                  {familyList}
                </select>
              </td>
              <td className="asset-mount">
                <TextField
                  onChange={(event) => changeAlreadyInsAsset(event)}
                  value={alreadyIns}
                  InputProps={{
                    inputComponent: NumberFormatCustomFiveDigits,
                    type: "tel",
                  }}
                  fullWidth={true}
                  color={"secondary"}
                />
              </td>
            </tr>
            <tr className={errorClassName1 + " finance"}>
              <td className="asset-title">③ 預金</td>
              <td>合計</td>
              <td className="asset-mount">
                <TextField
                  onChange={(event) => changeFinanceAsset(event)}
                  value={finance}
                  InputProps={{
                    inputComponent: NumberFormatCustomFiveDigits,
                    type: "tel",
                  }}
                  fullWidth={true}
                  color={"secondary"}
                />
              </td>
            </tr>
            <tr className="newIns">
              <td className="asset-title">④ 生命保険金(新)</td>
              <td>
                <select
                  ref={newInsRef}
                  onChange={(event) => assignAssets(event.target.value, 3)}
                >
                  {familyList}
                </select>
              </td>
              <td className="asset-mount">
                <TextField
                  onChange={(event) => changeNewInsAsset(event)}
                  value={newIns}
                  InputProps={{
                    inputComponent: NumberFormatCustomFiveDigits,
                    type: "tel",
                  }}
                  fullWidth={true}
                  color={"secondary"}
                />
              </td>
            </tr>
            <tr className={errorClassName2 + " finance"}>
              <td className="bottom-border">
                生命保険(新)
                <br />
                加入後預金
              </td>
              <td style={{ borderBottom: "solid 2px #a8a8a8" }}>③ - ④</td>
              <td
                style={{ borderBottom: "solid 2px #a8a8a8" }}
                className="asset-mount side-border"
              >
                {Intl.NumberFormat().format(finance - newIns)} 万円
              </td>
            </tr>
            {familyRow}
            {error1 && (
              <tr className="finance">
                <td></td>
                <td colSpan="2">
                  <span className="errorArea">{error1}</span>
                </td>
              </tr>
            )}
            {error2 && (
              <tr className="finance">
                <td></td>
                <td colSpan="2">
                  <span className="errorArea">{error2}</span>
                </td>
              </tr>
            )}
            <tr className="assetsSum">
              <td>分割対象計</td>
              <td>(① + ③)</td>
              <td className="asset-mount">
                {Intl.NumberFormat().format(sum)} 万円
              </td>
            </tr>
          </tbody>
        </table>
        <button className="reset-button" onClick={reset}>
          リセット
        </button>
      </div>
      <Divider style={{ backgroundColor: "#cfd8dc" }} />
      <div className="result-message-box">
        <table>
          <tbody>
            <tr>
              {!error1 && !error2 && (
                <div className={message[1]}>{message[0][0]}</div>
              )}
              {!error1 && !error2 && (
                <div className={message[1]}>{message[0][1]}</div>
              )}
              {!error1 && !error2 && message2 !== "" && (
                <div className={message2[1]}>{message2[0]}</div>
              )}
            </tr>
          </tbody>
        </table>
      </div>
      <Result
        haiguusha={haiguusha}
        child={child}
        home={home}
        finance={finance}
        assets={assets}
        sum={sum}
        error1={error1}
        error2={error2}
        handleMessage={handleMessage}
        handleMessage2={handleMessage2}
      />
      <div className="alert-area">
        <p>
          <span style={{ color: "#f44336" }}>
            [特定の相続人の生命保険金額が、遺産に対し30％を超えると警告が表示されます]
          </span>
        </p>
        <p>
          過去の遺産分割訴訟において、遺産に対する生命保険金の割合が高い場合には
          生命保険金を特別受益とみなし、遺産分割の対象と判断された例があります。
          本ツールでは30％を警告表示の基準としていますが、これを下回っても
          生命保険金が特別受益の対象とされる可能性はありますのでご注意ください。
        </p>
        <p>
          なお、過去の裁判における判断基準は遺産と生命保険金の割合だけでなく、
          被相続人と保険金受取人との生活実態など、総合的に考慮されています。
          本ツールは参考情報を示しており、遺産分割等の係争については一切の責任を負いません。
        </p>
      </div>
    </section>)}
    </>
  );
};

export default Iryubun;
